import { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { SSpanTitle, SSpanTitleSmall } from '~/components/styles/styles';
import { classic } from '~/themes';
import imgRoulette5 from '@assets/images/roulette/roulette-5.png';
import imgRoulette3 from '@assets/images/roulette/test.png';
import selection3Img from '@assets/images/roulette/roulette-3-selection.png';
import contour3Img from '@assets/images/roulette/roulette-3-contour.png';

import { StoredTheme } from '~/gql/theme/theme';
import ImageMappeurFixe from '~/components/ui/image-mapper-fixe';
import imgRouletteCenter from '@assets/images/roulette/roulette-game-center.png';
import selection5Img from '@assets/images/roulette/roulette-5-selection.png';
import { Zone } from '~/data/types';

type IProps = {
  onSelectTheme: (name: string) => void;
  themes: StoredTheme[];
  turn: number;
  theme?: StoredTheme;
};

//type CombinedThemeType = StoredTheme & Omit<Zone, "id"> & { idNum: number };

interface IChoiceTheme {
  id: number;
  title: string;
  mode: string;
}

const zones3: Zone[] = [
  {
    id: 1,
    type: 'poly',
    coords: [
      468, 111, 473, 451, 772, 630, 789, 596, 805, 563, 815, 526, 818, 488, 818,
      448, 814, 406, 804, 368, 794, 331, 776, 299, 758, 271, 733, 235, 706, 207,
      674, 180, 636, 156, 595, 137, 558, 125, 514, 117,
    ],
    coordsStr:
      '468,111,473,451,772,630,789,596,805,563,815,526,818,488,818,448,814,406,804,368,794,331,776,299,758,271,733,235,706,207,674,180,636,156,595,137,558,125,514,117',
    name: '', // en haut à droite
    rotate5: -120,
    angle: 30,
  },
  {
    id: 1,
    type: 'poly',
    coords: [
      177, 632, 474, 448, 771, 628, 753, 659, 724, 691, 691, 724, 653, 752, 607,
      775, 551, 792, 497, 803, 453, 801, 404, 797, 361, 782, 320, 768, 284, 749,
      253, 725, 225, 698, 195, 669, 179, 648, 174, 637,
    ],
    coordsStr:
      '177,632,474,448,771,628,753,659,724,691,691,724,653,752,607,775,551,792,497,803,453,801,404,797,361,782,320,768,284,749,253,725,225,698,195,669,179,648,174,637',
    name: '', // en bas au milleu
    rotate5: 0,
    angle: 180,
  },
  {
    id: 1,
    type: 'poly',
    coords: [
      470, 119, 473, 450, 176, 636, 156, 593, 143, 565, 136, 537, 131, 505, 129,
      472, 129, 438, 132, 400, 144, 364, 152, 329, 169, 294, 190, 257, 218, 225,
      246, 193, 292, 164, 326, 145, 371, 128, 408, 119, 452, 114, 468, 113,
    ],
    coordsStr:
      '470,119,473,450,176,636,156,593,143,565,136,537,131,505,129,472,129,438,132,400,144,364,152,329,169,294,190,257,218,225,246,193,292,164,326,145,371,128,408,119,452,114,468,113',
    name: '', // en haut à gauche
    rotate5: 120,
    angle: -30,
  },
];

const zones5: Zone[] = [
  {
    id: 1,
    type: 'poly',
    coords: [
      473, 122, 472, 474, 806, 364, 796, 338, 788, 322, 779, 303, 772, 290, 761,
      272, 751, 259, 735, 243, 722, 229, 704, 211, 682, 193, 661, 178, 628, 161,
      595, 145, 571, 137, 546, 130, 508, 123,
    ],
    coordsStr:
      '473,122,472,474,806,364,796,338,788,322,779,303,772,290,761,272,751,259,735,243,722,229,704,211,682,193,661,178,628,161,595,145,571,137,546,130,508,123',
    name: 'Histoire du chemin de fer',
    rotate5: -144,
    angle: 30,
  },
  {
    id: 2,
    type: 'poly',
    coords: [
      802, 363, 476, 474, 683, 755, 717, 726, 737, 708, 750, 692, 760, 677, 770,
      662, 779, 644, 792, 619, 808, 575, 819, 531, 823, 490, 822, 454, 820, 419,
      809, 376,
    ],
    coordsStr:
      '802,363,476,474,683,755,717,726,737,708,750,692,760,677,770,662,779,644,792,619,808,575,819,531,823,490,822,454,820,419,809,376',
    name: 'Les trains en Europe et dans le monde',
    rotate5: -72,
    angle: 100,
  },
  {
    id: 3,
    type: 'poly',
    coords: [
      682, 756, 475, 473, 266, 756, 291, 773, 311, 783, 335, 796, 361, 806, 382,
      812, 409, 818, 439, 824, 469, 824, 498, 823, 530, 817, 559, 813, 586, 804,
      613, 797, 643, 780,
    ],
    coordsStr:
      '682,756,475,473,266,756,291,773,311,783,335,796,361,806,382,812,409,818,439,824,469,824,498,823,530,817,559,813,586,804,613,797,643,780',
    name: 'Les textes et les institutions',
    rotate5: 0,
    angle: 180,
  },
  {
    id: 4,
    type: 'poly',
    coords: [
      143, 365, 470, 474, 267, 757, 248, 744, 229, 728, 211, 705, 192, 684, 178,
      666, 163, 638, 147, 604, 137, 572, 129, 547, 123, 515, 122, 486, 123, 451,
      126, 421, 135, 384,
    ],
    coordsStr:
      '143,365,470,474,267,757,248,744,229,728,211,705,192,684,178,666,163,638,147,604,137,572,129,547,123,515,122,486,123,451,126,421,135,384',
    name: 'Les infrastructures et l’exploitation',
    rotate5: 72.5,
    angle: -100,
  },
  {
    id: 5,
    type: 'poly',
    coords: [
      144, 366, 471, 475, 474, 121, 447, 124, 415, 127, 367, 140, 332, 152, 295,
      171, 273, 187, 240, 211, 208, 244, 174, 294, 159, 323,
    ],
    coordsStr:
      '144,366,471,475,474,121,447,124,415,127,367,140,332,152,295,171,273,187,240,211,208,244,174,294,159,323',
    name: 'Les véhicules',
    rotate5: 144,
    angle: -30,
  },
];

type TProps = IProps; // & ReturnType<typeof mapStateToProps> & TRootAction

export function ChoiceTheme({ onSelectTheme, turn, themes, theme }: TProps) {
  const [choice, setChoice] = useState<IChoiceTheme | null>(null);
  const [selectedTheme, setSelectedTheme] = useState<string | undefined>(
    undefined
  );
  const [selectedZone, setSelectedZone] = useState<Zone | undefined>(undefined);
  const [rouletteHeight, setRouletteHeight] = useState<number>(1);
  const [rouletteWidth, setRouletteWidth] = useState<number>(1);
  const observedDiv = useRef<HTMLImageElement>(null);

  const [zoneTheme3, setZoneTheme3] = useState<Zone[]>(zones3);
  const [themes3, setThemes3] = useState<StoredTheme[]>([]);

  const [selectedAngle, setSelectedAngle] = useState<number>(
    zones5[Math.floor(Math.random() * zones5.length)].angle
  );
  const [hoveredZone, setHoveredZone] = useState<Zone | undefined>(undefined);

  const choices: IChoiceTheme[] = [
    {
      id: 1,
      title: 'Choisis un thème',
      mode: 'mode solo',
    },
    {
      id: 2,
      title: 'Thème aléatoire',
      mode: 'mode solo',
    },
    {
      id: 3,
      title: 'Choisis un thème',
      mode: 'mode solo',
    },
  ];

  function handleHoverZone(zone: Zone | undefined) {
    setHoveredZone(zone);
  }

  function getRandomThemes(_themes: StoredTheme[], n: number): StoredTheme[] {
    if (_themes.length === 0 || n <= 0) {
      return [];
    }
    const shuffledThemes = [..._themes].sort(() => 0.5 - Math.random());
    return shuffledThemes.slice(0, Math.min(n, _themes.length));
  }

  useEffect(() => {
    if (theme) {
      return;
    }
    setSelectedZone(undefined);
    setSelectedAngle(0);
    setSelectedTheme(undefined);
    setChoice(null);

    const randomIndex = Math.floor(Math.random() * choices.length);
    setChoice(choices[randomIndex]);

    if (choices[randomIndex].id === 1) {
      setSelectedTheme(undefined);
      setSelectedZone(undefined);
    }
    if (choices[randomIndex].id === 2) {
      const randomAngle = Math.floor(Math.random() * zones5.length);
      setSelectedAngle(zones5[randomAngle].angle);

      setTimeout(() => {
        setSelectedZone(zones5[randomAngle]);
        setSelectedTheme(zones5[randomAngle].name);
        onSelectTheme(zones5[randomAngle].name);
      }, 3000);
    }

    if (choices[randomIndex].id === 3) {
      const randomThemes = getRandomThemes(themes, 3);
      setThemes3(randomThemes);
      const mappedZones: Zone[] = zones3.map((zone, index) => {
        return {
          ...zone,
          name: randomThemes[index].name,
        };
      });
      setZoneTheme3(mappedZones);
    }
  }, [turn]);

  useEffect(() => {
    if (!observedDiv.current) {
      return;
    }

    const resizeObserver = new ResizeObserver(() => {
      if (observedDiv?.current?.offsetWidth !== rouletteWidth) {
        setRouletteWidth(observedDiv?.current?.offsetWidth ?? 1);
      }
      if (observedDiv?.current?.offsetHeight !== rouletteHeight) {
        setRouletteHeight(observedDiv?.current?.offsetHeight ?? 1);
      }
    });
    resizeObserver.observe(observedDiv.current);

    return function cleanup() {
      resizeObserver.disconnect();
    };
  }, [observedDiv, rouletteHeight, rouletteWidth, turn]);

  function handleZoneClick(zone: Zone) {
    setSelectedZone(zone);
    setSelectedTheme(zone.name);
    onSelectTheme(zone.name);
  }

  function handleZone3Click(zone: Zone) {
    setSelectedZone(zone);
    setSelectedTheme(zone.name);
    onSelectTheme(zone.name);
  }

  function getTitleTheme(): string {
    if (selectedTheme) {
      return selectedTheme;
    } else {
      if (hoveredZone) {
        return hoveredZone.name;
      } else {
        return choice?.title || '';
      }
    }
  }

  return (
    <Container>
      {choice && (
        <>
          <SDivTitle>
            <SSpanTitleSmall $color={classic.token?.colorWhite}>
              {choice.mode}
            </SSpanTitleSmall>
            <SSpanTitle $color={classic.token?.colorWhite}>
              {getTitleTheme()}
            </SSpanTitle>
          </SDivTitle>
          {choice.id === 1 && (
            <>
              <SDivRouletteWrapper>
                <SRoulette>
                  <SRouletteImg ref={observedDiv} src={imgRoulette5} alt="" />
                  <ImageMappeurFixe
                    height={rouletteHeight}
                    width={rouletteWidth}
                    onZoneClick={handleZoneClick}
                    src={imgRoulette5}
                    zones={zones5}
                    onZoneHover={handleHoverZone}
                  />
                  {hoveredZone !== undefined && (
                    <SImgSelection5
                      $rotate={hoveredZone?.rotate5}
                      src={selection5Img}
                      alt=""
                    />
                  )}
                  {selectedTheme !== undefined && (
                    <SImgSelection5
                      $rotate={selectedZone?.rotate5}
                      src={selection5Img}
                      alt=""
                    />
                  )}
                </SRoulette>
              </SDivRouletteWrapper>
            </>
          )}
          {choice.id === 2 && (
            <>
              <SDivRouletteWrapper>
                <SRoulette>
                  <SRouletteImgMoved id="roulette" src={imgRoulette5} alt="" />
                  {selectedZone !== undefined && (
                    <SImgSelection5
                      $rotate={selectedZone?.rotate5}
                      src={selection5Img}
                      alt=""
                    />
                  )}
                  <RotatingImage
                    $angleValue={selectedAngle}
                    src={imgRouletteCenter}
                    alt=""
                  />
                </SRoulette>
              </SDivRouletteWrapper>
            </>
          )}
          {choice.id === 3 && zoneTheme3 && (
            <>
              <SDivRouletteWrapper>
                <SRoulette>
                  {zoneTheme3.map((zone3, ind) => (
                    <SImgSelection5
                      key={ind}
                      $rotate={zone3.rotate5}
                      src={
                        themes3.find((el) => el.name === zone3.name)
                          ?.wheelFileName
                      }
                      alt=""
                    />
                  ))}
                  {zoneTheme3.map((zone3, ind) => (
                    <SDivThemeLogo key={ind} $index={ind}>
                      <img
                        src={
                          themes3.find((el) => el.name === zone3.name)?.fileName
                        }
                        alt=""
                      />
                    </SDivThemeLogo>
                  ))}

                  <SRouletteImg ref={observedDiv} src={contour3Img} alt="" />
                  <ImageMappeurFixe
                    height={rouletteHeight}
                    width={rouletteWidth}
                    onZoneClick={handleZone3Click}
                    src={imgRoulette3}
                    zones={zoneTheme3}
                    onZoneHover={handleHoverZone}
                  />
                  {hoveredZone !== undefined && (
                    <SImgSelection5
                      $rotate={hoveredZone?.rotate5}
                      src={selection3Img}
                      alt=""
                    />
                  )}
                  {selectedZone !== undefined && (
                    <SImgSelection5
                      $rotate={selectedZone?.rotate5}
                      src={selection3Img}
                      alt=""
                    />
                  )}
                </SRoulette>
              </SDivRouletteWrapper>
            </>
          )}
        </>
      )}
    </Container>
  );
}

const SDivThemeLogo = styled.div<{ $index?: number }>`
  position: absolute;
  top: ${({ $index }) => {
    if ($index === 0) return '24%';
    if ($index === 1) return '56%';
    if ($index === 2) return '24%';
    return '-1000%';
  }};
  left: ${({ $index }) => {
    if ($index === 0) return '52%';
    if ($index === 1) return '34%';
    if ($index === 2) return '18%';
    return '-1000%';
  }};
  position: absolute;
  height: 30%;
  width: 30%;

  img {
    top: 0;
    left: 0;
    height: 100%;
    object-fit: contain;
    position: absolute;
    width: 100%;
  }
`;

const SImgSelection5 = styled.img<{ $rotate?: number }>`
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  transform: ${({ $rotate }) =>
    $rotate ? `translateX(-50%) rotate(${$rotate}deg)` : 'translateX(-50%)'};
  width: auto;
  pointer-events: none;
  @media screen and (max-width: 450px) {
    top: 50%;
    left: 0;
    height: auto;
    width: 100%;
    transform: ${({ $rotate }) =>
      $rotate ? `translateY(-50%) rotate(${$rotate}deg)` : 'translateY(-50%)'};
  }
`;

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  user-select: none;
  height: 100%;
`;

const SDivTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 12%;
  width: 100%;

  @media screen and (max-width: 450px) {
    height: 10%;
  }
`;
const SDivRouletteWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: 82%;
  width: 100%;
`;

const SRoulette = styled.div`
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  position: relative;
  width: auto;
  pointer-events: none;

  @media screen and (orientation: portrait) {
    height: auto;
    width: 100%;
  }
`;

const rotateAnimation = ($angleValue: number) => keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(${1080 + $angleValue}deg);
  }
`;

const SRouletteImg = styled.img<{ $zIndex?: number }>`
  height: 100%;
  width: auto;
  max-width: 100%;
  max-height: 100%;
  pointer-events: none;
  position: relative;
  z-index: ${({ $zIndex }) => ($zIndex ? $zIndex : 'auto')};

  @media screen and (orientation: portrait) {
    height: auto;
    width: 100%;
  }
`;

const RotatingImage = styled.img<{
  $angleValue: number;
  $shouldAnimate?: boolean;
}>`
  position: absolute;
  object-fit: contain;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  animation: ${({ $angleValue }) => rotateAnimation($angleValue)} 2s ease-out
    forwards;
  animation-delay: 1s;
`;

const SRouletteImgMoved = styled.img`
  height: 100%;
  width: auto;
  max-width: 100%;
  max-height: 100%;
  pointer-events: none;
  transition: transform 3000ms ease-in-out;

  @media screen and (orientation: portrait) {
    height: auto;
    width: 100%;
  }
`;
